import { createRoute, redirect, type ErrorComponentProps } from '@tanstack/react-router'

import { ErrorFallback } from '@/app/error-boundary'
import { AppShell } from '@/app/shell/app-shell'
import { getMe, getToken, hydrateIdentity } from '@/lib/auth'
import { IdentityUnavailable, IdentityUnavailableError } from './identity-unavailable'
import { rootRoute } from './root'

export const appRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: 'app',
  beforeLoad: async ({ context, location }) => {
    const toLogin = () =>
      redirect({
        to: '/auth/login',
        search: { redirect: location.href },
      })
    if (!context.isAuthenticated) throw toLogin()
    if (getMe() !== null) return
    await hydrateIdentity()
    if (getToken() === null) throw toLogin()
    if (getMe() === null) throw new IdentityUnavailableError()
  },
  pendingMs: 0,
  component: AppShell,
  errorComponent: AppRouteError,
})

function AppRouteError({ error }: ErrorComponentProps) {
  return error instanceof IdentityUnavailableError ? <IdentityUnavailable /> : <ErrorFallback />
}
